module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/portal-shipment/portal-shipment.component.css
// module id = ./src/app/portal-shipment/portal-shipment.component.css
// module chunks = main